import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

var FbIcon = function FbIcon() {
  return _jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("path", {
      d: "M24 12C24 5.3719 18.6281 0 12 0C5.3719 0 0 5.3719 0 12C0 17.9907 4.3875 22.9547 10.125 23.8547V15.4688H7.0781V12H10.125V9.35625C10.125 6.3492 11.9156 4.6875 14.6578 4.6875C15.9703 4.6875 17.3438 4.92188 17.3438 4.92188V7.875H15.8297C14.3391 7.875 13.875 8.8008 13.875 9.75V12H17.2031L16.6711 15.4688H13.875V23.8547C19.6125 22.9547 24 17.9907 24 12Z",
      fill: "#1877F2"
    }), _jsx("path", {
      d: "M16.6711 15.4688L17.2031 12H13.875V9.75C13.875 8.8008 14.339 7.875 15.8297 7.875H17.3437V4.92188C17.3437 4.92188 15.9703 4.6875 14.6578 4.6875C11.9156 4.6875 10.125 6.3492 10.125 9.35625V12H7.07806V15.4688H10.125V23.8547C10.7367 23.9508 11.3625 24 12 24C12.6375 24 13.2633 23.9508 13.875 23.8547V15.4688H16.6711Z",
      fill: "white"
    })]
  }));
};

export default FbIcon;